module.exports = __webpack_public_path__ + "img/BNZ.024b4d20.jpeg";